(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5853],{

/***/ 59212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./common/data/bank_country.json
var bank_country = __webpack_require__(55881);
// EXTERNAL MODULE: ./common/data/bank_emis.json
var bank_emis = __webpack_require__(33148);
// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/common/economic-substance/index.js + 2 modules
var economic_substance = __webpack_require__(31130);
;// CONCATENATED MODULE: ./pages/offshore/company-formation/belize/economic-substance/data.json
var data_namespaceObject = JSON.parse('{"country":"Belize","imgAlt":"Belize economic substance service","breadcrumbs":[{"title":"Company Formation","uri":"/company-formation"},{"title":"Belize","uri":"/company-formation/belize"},{"title":"Economic Substance","uri":"/company-formation/belize/economic-substance"}],"dataPageType":[{"title":"Company Formation","uri":"/company-formation/belize"},{"title":"Open Bank Account","uri":"/company-formation/belize/open-bank-account"},{"title":"Other Services","uri":"/company-formation/belize/other-services"},{"title":"Economic Substance","uri":"/company-formation/belize/economic-substance"}],"dataEconomicSubstance":{"title":"Belize Economic Substance","description":"Are you finding it challenging to manage the compliance duties associated with the Economic Substance requirement in Belize? Here we provide you with essential services to address your substance concerns, from assessment to filing.","src":"/assets/images/offshore/country/belize/economic_requirement-belize.png"},"dataTable":[{"left":"","middle":"Included Entity","right":"Non-Included Entity"},{"left":"Condition","middle":["Entities regulated under IFSC Act; or","Belize BC conducting relevant activities"],"right":["Not conducting any relevant activities; or","Controlled/managed outside Belize, and is tax resident outside Belize"]},{"left":"Compliance","middle":["Conducting its core income-generating activities in Belize","Adequate expenditure, employees and appropriate premises in Belize","Management and control in Belize"],"right":["None"]},{"left":"Reporting","middle":["Form C: Pure Equity Holding Company","Form B: General activities"],"right":["Form D"]}],"dataFaqs":[{"name":"How can Economic Substance Requirements affect your Belize company?","content":"<p>Certain Belize international business companies (BCs) carrying on relevant activities or regulated under Belize IFSC Act shall be subject to the Economic Substance Act, 2019 in Belize.</p><p>“Relevant activities” under the Belize ES regime include Banking, Insurance, Fund Management, Finance and leasing, Headquarters, Shipping, Holding company, and Distribution and service centers.</p><p>All in-scope BCs under this regime must fulfill the compliance duties or economic substance test for each relevant activity they engage in.</p>"},{"name":"What are “relevant activities” under Belize ES regime?","content":"<p>Economic substance requirements in Belize are applicable to legal entities that engage in one or more relevant activities as the followings:</p><ul><li>Banking</li><li>Insurance</li><li>Fund management</li><li>Finance and leasing</li><li>Headquarters</li><li>Shipping</li><li>Holding business/pure equity holding</li><li>Distribution and service centre</li></ul>"},{"name":"What are the compliance requirements for included entities under the Belize ES rule?","content":"<p>Included entities must demonstrate economic substance in Belize. The entity will be considered compliant with the economic substance requirements if it can meet the following tests:</p><ul><li>Conducting its core income-generating activities in Belize</li><li>Adequate expenditure, employees and appropriate premises in Belize</li><li>Management and control in Belize</li></ul><p>Note that core income-generating activities (CIGA) are varied depending on each business activity. Entities engaging in holding company business will be subject to a reduced test if comparing to general business activities.</p>"},{"name":"What are the deadlines for your Belize entities to submit the Economic Substance Report?","content":"<p>In-scope Belize companies are required to report to the competent authority within nine months of the end of a fiscal year.</p>"}]}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/offshore/company-formation/belize/economic-substance/index.js






var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "offshore",
    navLight: true,
    page: data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(economic_substance/* default */.Z, {
      data: data,
      dataJson: data_namespaceObject,
      dataBank: {
        traditional: bank_country/* belize */.P0,
        emi: bank_emis/* belize */.P0
      }
    })
  });
}

/***/ }),

/***/ 4838:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/company-formation/belize/economic-substance",
      function () {
        return __webpack_require__(59212);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,4090,9738,7447,9156,58,5881,1130,2888,179], function() { return __webpack_exec__(4838); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);